

import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import { request, vali, wxapi, loading } from './utils'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

import './assets/css/common.css'

Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
Vue.use(WechatPlugin)

Vue.prototype.request = request
Vue.prototype.wxapi = wxapi
Vue.prototype.vali = vali()
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
if (!store.state.token && to.path !== '/about') {
loading.call(Vue, res => {
store.commit('user', res.user_info)
store.commit('token', res.token)
next(to.fullPath.replace(/\?code.*?STATE|&code.*?STATE/g, ''))
}, vali().getSearch()['code'])
} else if (to.path !== '/searchDetail' && to.path !== '/login' && to.path !== '/about' && !store.state.user.phone) {
store.commit('router', to.fullPath)
next('/login')
} else {
next()
}
})

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>',
created () {
this.request({
url: '/api/User/getConfig',
type: 'post',
data: {
url: location.href.replace(/#.+/, '')
},
success: res => {
Vue.wechat.config(this.vali.merge(res.data, {
jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'chooseImage', 'uploadImage', 'previewImage', 'getLocalImgData', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'closeWindow', 'getLocation']
}))
}
})
}
})



// WEBPACK FOOTER //
// ./src/main.js